import { createEmptyTabSection, mapSection } from 'utils/section/tabSection';
import type { ModulesAndAgendasState } from '../index';
import type { GetAgendasFormRes } from 'types';

export const syncSections = (state: ModulesAndAgendasState, payload: GetAgendasFormRes) => {
  if (payload.tabSections?.length === 0) {
    state.tabSections = [
      {
        sections: [createEmptyTabSection()],
        tab: { number: 0 },
      },
    ];
  } else {
    state.tabSections = payload.tabSections.map(({ tab, sections }) => ({
      tab: { ...tab },
      sections: sections.map((section) => mapSection(section)),
    }));
  }
};
